import { render, staticRenderFns } from "./qikan.vue?vue&type=template&id=5ef887fc&scoped=true&"
import script from "./qikan.vue?vue&type=script&lang=js&"
export * from "./qikan.vue?vue&type=script&lang=js&"
import style0 from "./qikan.vue?vue&type=style&index=0&id=5ef887fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef887fc",
  null
  
)

export default component.exports